import { createSelector } from '@reduxjs/toolkit';
import { clone } from 'lodash';

import { emptyArr, venturingCoreAwardsIds } from '@shared/constants';
import {
  awardsSel,
  dictionarySel,
} from '@shared/duck/selectors/general.selectors';

import { dictionaryIds, moduleName } from '../constants';

export {
  allAwardsSel,
  ranksSel,
  ssElectivesSel,
  adventuresSel,
  meritBadgesSel,
} from '@shared/duck/selectors/general.selectors';
export { awardsSel, dictionarySel };

const moduleSel = state => state[moduleName];
const dataSel = state => moduleSel(state).data;
const loadingSel = state => moduleSel(state).loading;

export const dictionaryLoadedSel = (state, id) => Boolean(dataSel(state)[id]);
export const dictionaryLoadingSel = (state, id) =>
  Boolean(loadingSel(state)[id]);
export const dictionariesLoadedSel = (state, ids) =>
  ids.reduce((loaded, id) => loaded || dictionaryLoadedSel(state, id), false);
export const dictionariesLoadingSel = (state, ids) =>
  ids.reduce(
    (loading, id) => loading || dictionaryLoadingSel(state, id),
    false,
  );

export const adventuresLoadedSel = state =>
  dictionaryLoadedSel(state, dictionaryIds.ADVENTURES);
export const adventuresLoadingSel = state =>
  dictionaryLoadingSel(state, dictionaryIds.ADVENTURES);

export const coreAwardsSel = createSelector(
  awardsSel,
  awards =>
    awards
      .filter(({ id }) => venturingCoreAwardsIds.includes(id))
      .map(coreAward => ({ level: coreAward.id, ...coreAward })), //small hack, the id can be used as the level
);
export const awardsLoadedSel = state =>
  dictionaryLoadedSel(state, dictionaryIds.AWARDS);
export const awardsLoadingSel = state =>
  dictionaryLoadingSel(state, dictionaryIds.AWARDS);

export const ranksLoadedSel = state =>
  dictionaryLoadedSel(state, dictionaryIds.RANKS);
export const ranksLoadingSel = state =>
  dictionaryLoadingSel(state, dictionaryIds.RANKS);

export const ssElectivesLoadedSel = state =>
  dictionaryLoadedSel(state, dictionaryIds.SSELECTIVES);

export const ssElectivesLoadingSel = state =>
  dictionaryLoadingSel(state, dictionaryIds.SSELECTIVES);

export const meritBadgesLoadedSel = state =>
  dictionaryLoadedSel(state, dictionaryIds.MERIT_BADGES);
export const meritBadgesLoadingSel = state =>
  dictionaryLoadingSel(state, dictionaryIds.MERIT_BADGES);


export const schoolsSel = state => {
  const list = dictionarySel(state, dictionaryIds.SCHOOLS) || emptyArr;

  if (list && list.length > 24) {
    const resultList = clone(list);
    resultList.length = 24;
    return resultList;
  }

  return list || emptyArr;
};

export const advancementSel = ({ state, advancementType, advancementId }) =>
  dictionarySel(state, advancementType).find(({ id }) => id == advancementId) ||
  {};
